if (!customElements.get('parfumine-sticky-add-to-cart')) {
  customElements.define(
    'parfumine-sticky-add-to-cart',
    class ParfumineStickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.stickyButton = this.querySelector('.parfumine-sticky-add-to-cart__button');
        this.stickyLabel = this.querySelector('[data-parfumine-sticky-label]');
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.frameRequest = null;

        // Seçili varyantın fiyatı buton metninin yanında gösterilir.
        this.stickyPrice = this.querySelector('[data-parfumine-sticky-price]');
        if (!this.stickyPrice && this.stickyButton) {
          this.stickyPrice = document.createElement('span');
          this.stickyPrice.className = 'parfumine-sticky-add-to-cart__price';
          this.stickyPrice.dataset.parfumineStickyPrice = '';
          this.stickyPrice.hidden = true;
          this.stickyButton.append(this.stickyPrice);
        }

        this.handleStickyClick = this.handleStickyClick.bind(this);
        this.handleViewportUpdate = this.handleViewportUpdate.bind(this);
        this.handleProductInfoLoaded = this.handleProductInfoLoaded.bind(this);

        this.stickyButton?.addEventListener('click', this.handleStickyClick);
        window.addEventListener('scroll', this.handleViewportUpdate, { passive: true });
        window.addEventListener('resize', this.handleViewportUpdate, { passive: true });
        document.addEventListener('product-info:loaded', this.handleProductInfoLoaded);

        this.productObserver = new MutationObserver(() => this.refresh());
        this.observeProductInfo();
        this.removeAttribute('hidden');
        this.refresh();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleStickyClick);
        window.removeEventListener('scroll', this.handleViewportUpdate);
        window.removeEventListener('resize', this.handleViewportUpdate);
        document.removeEventListener('product-info:loaded', this.handleProductInfoLoaded);
        this.productObserver?.disconnect();

        if (this.frameRequest) window.cancelAnimationFrame(this.frameRequest);
        this.setVisible(false);
      }

      observeProductInfo() {
        const productInfo = document.getElementById(this.dataset.productInfoId);
        if (productInfo === this.productInfo) return;

        this.productObserver?.disconnect();
        this.productInfo = productInfo;

        if (this.productInfo) {
          this.productObserver.observe(this.productInfo, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'disabled', 'aria-disabled'],
          });
        }
      }

      handleProductInfoLoaded(event) {
        if (event.target?.id !== this.dataset.productInfoId) return;
        this.observeProductInfo();
        this.refresh();
      }

      // Ana ürün formunu gönderir: seçili varyant, sepet çekmecesi ve hata mesajları ana butonla aynı yoldan geçer.
      handleStickyClick() {
        if (!this.mainButton || this.stickyButton?.disabled) return;

        const form = this.mainButton.form;
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(this.mainButton);
        } else {
          this.mainButton.click();
        }
      }

      handleViewportUpdate() {
        if (this.frameRequest) return;

        this.frameRequest = window.requestAnimationFrame(() => {
          this.frameRequest = null;
          this.updateVisibility();
        });
      }

      // Ana fiyat bloğundaki görünen fiyatı okur; para birimi kodu (EUR) dar butonda yer açmak için atılır.
      readPrice() {
        const price = this.productInfo?.querySelector('[id^="price-"] .price');
        if (!price) return '';

        const selector = price.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale'
          : '.price__regular .price-item--regular';
        const text = price.querySelector(selector)?.textContent.trim() || '';

        return text.replace(/\s*[A-Z]{3}$/, '');
      }

      setText(element, text) {
        if (element && element.textContent !== text) element.textContent = text;
      }

      refresh() {
        this.observeProductInfo();
        this.mainButton = document.getElementById(this.dataset.submitId);

        if (!this.mainButton || !this.stickyButton) {
          this.setVisible(false);
          return;
        }

        const mainLabel = this.mainButton.querySelector(':scope > span')?.textContent.trim();
        this.setText(this.stickyLabel, mainLabel || this.dataset.defaultLabel || '');

        const isLoading = this.mainButton.classList.contains('loading');
        const isDisabled =
          this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = isDisabled;
        this.stickyButton.setAttribute('aria-disabled', String(isDisabled));
        this.stickyButton.classList.toggle('is-loading', isLoading);

        if (this.stickyPrice) {
          const price = this.mainButton.disabled ? '' : this.readPrice();
          this.setText(this.stickyPrice, price);
          this.stickyPrice.hidden = price === '';
        }

        this.updateVisibility();
      }

      updateVisibility() {
        if (!this.mainButton) {
          this.setVisible(false);
          return;
        }

        // Mobilde ana buton ekranın üstünde kaldıktan sonra görünür; masaüstünde eski eşik korunur.
        const hasReachedStickyTrigger = this.desktopQuery.matches
          ? window.scrollY >= 420
          : this.mainButton.getBoundingClientRect().bottom < 0;

        this.setVisible(Boolean(hasReachedStickyTrigger));
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);

        const hasVisibleStickyButton = Boolean(
          document.querySelector('parfumine-sticky-add-to-cart.is-visible')
        );
        document.body.classList.toggle('parfumine-sticky-cart-visible', hasVisibleStickyButton);
      }
    }
  );
}
